export default __webpack_public_path__ + "static/media/ico-ig.b30c7771.svg";